import { render, staticRenderFns } from "./SpoiledSettings.vue?vue&type=template&id=8ff109da&scoped=true&"
import script from "./SpoiledSettings.vue?vue&type=script&lang=js&"
export * from "./SpoiledSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff109da",
  null
  
)

export default component.exports